import React, { Component } from "react";
import styles from "./taskTripSettings.module.scss";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import FilterAndSearchTools from "../../FilterTools/FilterAndSearchTools";
import { withLogisticRoutes } from "../../../../shared/containers/containerLogisticRoutes";
import { NavLink } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import { Radio } from "@mui/material";
import TaskTripUnitsSettings from "./TaskTripUnitsSettings";
import TaskTripRotesSettings from "./TaskTripRotesSettings";
import { withSignalR } from "../../../../shared/containers/containerSignalR";

class TaskTripSettings extends Component {
  componentDidMount() {
    const { onGetMonitoringsTaskTrip } = this.props;
    const taskTripId = window.location.pathname.replace("/logistic/monitorings", "").replace("/", "").replace("settings", "");

    if (taskTripId !== "" && taskTripId !== "/") {
      onGetMonitoringsTaskTrip({ id: taskTripId });
    }
  }

  componentDidUpdate(preProps) {
    const {
      onHandleRecieveTaskTripInformations,
      onSetMonitoringSettingsState,
      monitoringTaskTripDataState,
      monitoringSettingsState,
      monitoringTaskTrip,
      dataConnectionStateSR,
      dataStartConnectionStateSR,
      dataUserGroupStateSR,
      monitoringTaskTripDataStateSR,
      connectionSR,
    } = this.props;

    if (monitoringTaskTripDataState === states.READY && preProps.monitoringTaskTripDataState === states.REQUEST) {

      monitoringSettingsState.unitState = {
        id: monitoringTaskTrip.id,
        title: monitoringTaskTrip.title,
        unitId: null,
        routeId: null,
        controlPointId: null,
      };

      onSetMonitoringSettingsState(monitoringSettingsState);
    }

    // trigger to start recieve lastState
    if (
      dataConnectionStateSR === states.READY &&
      dataStartConnectionStateSR === states.READY &&
      dataUserGroupStateSR === states.READY &&
      monitoringTaskTripDataStateSR === states.NOT_REQUESTED
    ) {
      onHandleRecieveTaskTripInformations(connectionSR, monitoringTaskTrip);
    }
  }

  onSetMode(value) {
    const { monitoringSettingsState, onSetMonitoringSettingsState } = this.props;

    monitoringSettingsState.modificationType = value;
    onSetMonitoringSettingsState(monitoringSettingsState);
  }

  render() {
    const { monitoringTaskTrip, monitoringTaskTripDataState, onGetLogisticRoutes, monitoringSettingsState } = this.props;

    if (monitoringTaskTrip === null || monitoringTaskTrip === undefined || monitoringTaskTripDataState === states.REQUEST)
      return (
        <div className={styles.taskTripSettingContainer}>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <Preloader />
          </div>
        </div>
      );

    return (
      <div className={styles.taskTripSettingContainer}>
        <div className={styles.taskTripToolContainer}>
          <FilterAndSearchTools onFilter={onGetLogisticRoutes} titleSearch={"Поиск по маршрутам"} />

          <TooltipWrapper title={"Закрыть"} position="left">
            <NavLink to={`/logistic/monitorings/${monitoringTaskTrip.id}`}>
              <HighlightOffIcon style={{ color: "red" }} />
            </NavLink>
          </TooltipWrapper>
        </div>

        <div className={styles.taskTripTitleContainer}>
          <h2>{monitoringTaskTrip.title}</h2>
          <p>{monitoringTaskTrip.description}</p>
        </div>

        <div className={styles.taskTripModeToolContainer}>
          <div
            className={styles.radioButtomItem}
            onClick={() => {
              this.onSetMode(0);
            }}
          >
            <Radio checked={monitoringSettingsState.modificationType === 0} size="small" />
            <span> Назнгачение ТС к текущему рейсу </span>
          </div>
          <div
            className={styles.radioButtomItem}
            style={{ marginLeft: "10px" }}
            onClick={() => {
              this.onSetMode(1);
            }}
          >
            <Radio checked={monitoringSettingsState.modificationType === 1} size="small" />
            <span> Добавление маршрутов к текущему рейсу</span>
          </div>
        </div>

        <div>
          <TaskTripUnitsSettings />
          <TaskTripRotesSettings />
        </div>
      </div>
    );
  }
}

export default withSignalR(withLogisticRoutes(withMonitoringTaskTrips(React.memo(TaskTripSettings))));
